import {Security} from '@okta/okta-react';
import {useNavigate} from 'react-router-dom';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';

// One-time cleanup of legacy localStorage keys (migration to sessionStorage)
// WSCC-20752: Clear accumulated Okta localStorage to resolve performance issues
// Guard ensures this only runs once per session to avoid unnecessary overhead
if (typeof window !== 'undefined' && !sessionStorage.getItem('okta-ls-cleaned')) {
  const legacyKeys = [
    'okta-token-storage',
    'okta-cache-storage',
    'okta-shared-transaction-storage',
    'okta-pkce-storage',
  ];

  legacyKeys.forEach((key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
  });

  sessionStorage.setItem('okta-ls-cleaned', '1');
}

const options = {
  issuer: window.env?.OKTA_ISSUER,
  clientId: window.env?.OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: [
    'openid',
    'profile',
    'email',
    'api.wellsky.payer.wscc.payerhub.admin',
  ],
  tokenManager: {
    storage: 'sessionStorage',
    autoRemove: true,
    clearPendingRemoveTokens: true,
    expireEarlySeconds: 30, // SDK default - safe for all token TTL configurations
  },
};
const oktaAuth = new OktaAuth(options);

export const SecurityProvider = ({children}) => {
  const navigate = useNavigate();

  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
      replace: true,
    });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};
